import React from 'react';
import { Camera, Image } from 'lucide-react';
import { Cliente, Contenuto } from '../types';
import { postGraficiDelMese, targetPostGraficiMese } from '../utils/contenutiDaScrivere';

/**
 * Post grafici e caroselli foto del mese di un cliente, scritti su previsti (03/11/2026, Michel):
 * due righe separate, ognuna solo se la scheda del cliente la prevede. Sotto il nome del cliente
 * nelle card del Copywriting e di «Da gestire». `postGraficiSettimana` è il totale dei post a
 * settimana, `caroselliFotoSettimana` quanti sono caroselli foto: i post grafici sono il resto.
 */
// Il cliente può arrivare anche solo con id e nome (schede di Da gestire): allora non si mostra niente.
type ClientePost = Pick<Cliente, 'id'> & Partial<Pick<Cliente, 'postGrafici' | 'postGraficiSettimana' | 'caroselliFotoSettimana'>>;

const ContatorePost: React.FC<{ cliente: ClientePost; contenuti: Contenuto[]; mese: number; anno: number }> = ({ cliente, contenuti, mese, anno }) => {
  if (!cliente.postGrafici || (cliente.postGraficiSettimana || 0) <= 0) return null;
  const foto = Math.min(cliente.caroselliFotoSettimana || 0, cliente.postGraficiSettimana || 0);
  const grafici = (cliente.postGraficiSettimana || 0) - foto;
  const righe = [
    { chiave: 'grafica' as const, settimana: grafici, nome: 'post grafici', Icona: Image, titolo: 'Post grafici del mese: scritti su previsti' },
    { chiave: 'foto' as const, settimana: foto, nome: 'caroselli foto', Icona: Camera, titolo: 'Caroselli foto del mese: scritti su previsti' },
  ].filter((r) => r.settimana > 0);
  return (
    <>
      {righe.map(({ chiave, settimana, nome, Icona, titolo }) => (
        <div key={chiave} className="flex items-center gap-1 mt-0.5 text-[10px] sm:text-xs text-slate-500 dark:text-slate-400" title={titolo}>
          <Icona className="w-3 h-3 flex-shrink-0" />
          <span>
            <span className="font-semibold text-slate-700 dark:text-slate-300">
              {postGraficiDelMese(contenuti, cliente.id, mese, anno, chiave)}/{targetPostGraficiMese(settimana)}
            </span> {nome}
          </span>
        </div>
      ))}
    </>
  );
};

export default ContatorePost;
